import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router';
import jwt from 'jwt-decode';
import { Role, rules } from '../components/Auth/PriorityRules';
import Loading from '../pages/Loading';

const PrivateRoute = () => {
	const location = useLocation();
	const storage = localStorage.getItem('userData');
	const [isAuthenticated, setIsAuthenticated] = useState(null); // null means loading state
	const [userRole, setUserRole] = useState(null);

	useEffect(() => {
		if (storage) {
			try {
				const userData = jwt(JSON.parse(storage).access);
				setUserRole(userData.Role);
				setIsAuthenticated(true);
			} catch (error) {
				console.log(error);
				setIsAuthenticated(false);
			}
		} else {
			setIsAuthenticated(false);
		}
	}, []);

	if (isAuthenticated === null) {
		return <Loading />;
	}

	if (!isAuthenticated) {
		return <Navigate to="/login" replace />;
	}

	const allowedPaths = rules[userRole]?.allowed_paths || [];
	if (!allowedPaths.includes(location.pathname)) {
		const homeUri = userRole === Role.Teacher ? '/profesor' : '/';
		return <Navigate to={homeUri} replace />;
	}

	return <Outlet />;
};

export default PrivateRoute;
